import {validateValue} from '../helpers/validation'

// Begin action types
export const CLEAR_PRODUCTION_SEARCH_FIELDS = 'CLEAR_PRODUCTION_SEARCH_FIELDS'
export const VALIDATE_PRODUCTION_SEARCH_FIELD = 'VALIDATE_PRODUCTION_SEARCH_FIELD'

export const CLEAR_PRODUCTION = 'CLEAR_PRODUCTION'
export const FETCH_PRODUCTION_OVERVIEW_SUCCESS = 'FETCH_PRODUCTION_OVERVIEW_SUCCESS'
export const FETCH_PRODUCTION_VACANCIES_SUCCESS = 'FETCH_PRODUCTION_VACANCIES_SUCCESS'
export const FETCH_PRODUCTION_VOICE_TESTS_SUCCESS = 'FETCH_PRODUCTION_VOICE_TESTS_SUCCESS'

export const FETCH_PRODUCTION_ACTIVATE_DATA_SUCCESS = 'FETCH_PRODUCTION_ACTIVATE_DATA_SUCCESS'
export const VALIDATE_PRODUCTION_ACTIVATE_FIELD = 'VALIDATE_PRODUCTION_ACTIVATE_FIELD'
export const SUBMIT_PRODUCTION_ACTIVATE_FIELDS = 'SUBMIT_PRODUCTION_ACTIVATE_FIELDS'
export const CLEAR_PRODUCTION_ACTIVATE_FIELDS = 'CLEAR_PRODUCTION_ACTIVATE_FIELDS'
// End action types

export const clearProductionSearchFields = () => ({
  type: CLEAR_PRODUCTION_SEARCH_FIELDS
});
export const validateProductionSearchField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_PRODUCTION_SEARCH_FIELD,
    field
  }
}

export const clearProduction = () => ({
  type: CLEAR_PRODUCTION
});
export const fetchProductionOverviewSuccess = (overview) => ({
  type: FETCH_PRODUCTION_OVERVIEW_SUCCESS,
  overview
});
export const fetchProductionVacanciesSuccess = (vacancies) => ({
  type: FETCH_PRODUCTION_VACANCIES_SUCCESS,
  vacancies
});
export const fetchProductionVoiceTestsSuccess = (voiceTests) => ({
  type: FETCH_PRODUCTION_VOICE_TESTS_SUCCESS,
  voiceTests
});

export const fetchProductionActivateDataSuccess = (data) => ({
  type: FETCH_PRODUCTION_ACTIVATE_DATA_SUCCESS,
  data
});
export const validateProductionActivateField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_PRODUCTION_ACTIVATE_FIELD,
    field
  }
}
export const submitProductionActivateFields = (fields) => {
  return {
    type: SUBMIT_PRODUCTION_ACTIVATE_FIELDS,
    fields
  }
}
export const clearProductionActivateFields = (fields) => {
  return {
    type: CLEAR_PRODUCTION_ACTIVATE_FIELDS
  }
}